var _path, _path2, _path3, _rect, _path4, _path5, _g, _path6, _path7, _g2, _path8, _path9, _g3, _path10, _path11, _g4, _path12, _path13, _g5, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9612)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9612)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V0H0V20Z",
    fill: "#30C375"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 4,
    height: 20,
    fill: "#DE414F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.00004C7.10457 4.00004 8 3.40309 8 2.66671C8 1.93033 7.10457 1.33337 6 1.33337C4.89543 1.33337 4 1.93033 4 2.66671C4 3.40309 4.89543 4.00004 6 4.00004Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2858_9612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 4,
    height: 3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.00004C7.10457 4.00004 8 3.40309 8 2.66671C8 1.93033 7.10457 1.33337 6 1.33337C4.89543 1.33337 4 1.93033 4 2.66671C4 3.40309 4.89543 4.00004 6 4.00004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2858_9612)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 3.33333C6.36835 3.33333 6.66683 3.03486 6.66683 2.66667C6.66683 2.29848 6.36835 2 6.00016 2C5.63197 2 5.3335 2.29848 5.3335 2.66667C5.3335 3.03486 5.63197 3.33333 6.00016 3.33333Z",
    fill: "#DD404F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1.33337,
    width: 2,
    height: 1.33333,
    fill: "#FBAF29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2.66675,
    width: 2,
    height: 1.33333,
    fill: "#FBAF29"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 18.6667C7.10457 18.6667 8 18.0697 8 17.3333C8 16.597 7.10457 16 6 16C4.89543 16 4 16.597 4 17.3333C4 18.0697 4.89543 18.6667 6 18.6667Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2858_9612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 16,
    width: 4,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 18.6667C7.10457 18.6667 8 18.0697 8 17.3333C8 16.597 7.10457 16 6 16C4.89543 16 4 16.597 4 17.3333C4 18.0697 4.89543 18.6667 6 18.6667Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2858_9612)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 18.0001C6.36835 18.0001 6.66683 17.7016 6.66683 17.3334C6.66683 16.9652 6.36835 16.6667 6.00016 16.6667C5.63197 16.6667 5.3335 16.9652 5.3335 17.3334C5.3335 17.7016 5.63197 18.0001 6.00016 18.0001Z",
    fill: "#DD404F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 2,
    height: 1.33333,
    fill: "#FBAF29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17.3334,
    width: 2,
    height: 1.33333,
    fill: "#FBAF29"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C7.10457 12 8 11.4031 8 10.6667C8 9.93033 7.10457 9.33337 6 9.33337C4.89543 9.33337 4 9.93033 4 10.6667C4 11.4031 4.89543 12 6 12Z",
    fill: "#28AE67"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2858_9612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 9,
    width: 4,
    height: 3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C7.10457 12 8 11.4031 8 10.6667C8 9.93033 7.10457 9.33337 6 9.33337C4.89543 9.33337 4 9.93033 4 10.6667C4 11.4031 4.89543 12 6 12Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2858_9612)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99984 11.3333C6.73622 11.3333 7.33317 11.0349 7.33317 10.6667C7.33317 10.2985 6.73622 10 5.99984 10C5.26346 10 4.6665 10.2985 4.6665 10.6667C4.6665 11.0349 5.26346 11.3333 5.99984 11.3333Z",
    fill: "#DD404F"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.6667C7.10457 14.6667 8 14.3682 8 14C8 13.6319 7.10457 13.3334 6 13.3334C4.89543 13.3334 4 13.6319 4 14C4 14.3682 4.89543 14.6667 6 14.6667Z",
    fill: "#28AE67"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2858_9612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 13,
    width: 4,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.6667C7.10457 14.6667 8 14.3682 8 14C8 13.6319 7.10457 13.3334 6 13.3334C4.89543 13.3334 4 13.6319 4 14C4 14.3682 4.89543 14.6667 6 14.6667Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2858_9612)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.00004C7.10457 8.00004 8 7.40309 8 6.66671C8 5.93033 7.10457 5.33337 6 5.33337C4.89543 5.33337 4 5.93033 4 6.66671C4 7.40309 4.89543 8.00004 6 8.00004Z",
    fill: "#FBAF29"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2858_9612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 4,
    height: 3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.00004C7.10457 8.00004 8 7.40309 8 6.66671C8 5.93033 7.10457 5.33337 6 5.33337C4.89543 5.33337 4 5.93033 4 6.66671C4 7.40309 4.89543 8.00004 6 8.00004Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2858_9612)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 7.33333C6.36835 7.33333 6.66683 7.03486 6.66683 6.66667C6.66683 6.29848 6.36835 6 6.00016 6C5.63197 6 5.3335 6.29848 5.3335 6.66667C5.3335 7.03486 5.63197 7.33333 6.00016 7.33333Z",
    fill: "#DD404F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5.33337,
    width: 1.33333,
    height: 2.66667,
    fill: "#28AE67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6665,
    y: 5.33337,
    width: 1.33333,
    height: 2.66667,
    fill: "#28AE67"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8225 4.23824C14.5858 4.52029 14.6226 4.94079 14.9047 5.17746C15.1867 5.41413 15.6072 5.37734 15.8439 5.09529C16.0806 4.81324 16.0438 4.39274 15.7617 4.15607C15.4797 3.9194 15.0592 3.95619 14.8225 4.23824ZM13.0952 6.82273C12.8132 6.58607 12.3927 6.62286 12.156 6.90491C11.9193 7.18695 11.9561 7.60746 12.2382 7.84413C12.5202 8.08079 12.9407 8.044 13.1774 7.76196C13.414 7.47991 13.3773 7.0594 13.0952 6.82273ZM11.7617 5.4894C11.4797 5.25273 11.0592 5.28952 10.8225 5.57157C10.5858 5.85362 10.6226 6.27413 10.9047 6.51079C11.1867 6.74746 11.6072 6.71067 11.8439 6.42862C12.0806 6.14657 12.0438 5.72607 11.7617 5.4894ZM14.4282 2.82273C14.1462 2.58607 13.7257 2.62286 13.489 2.90491C13.2523 3.18695 13.2891 3.60746 13.5712 3.84413C13.8532 4.08079 14.2737 4.04401 14.5104 3.76196C14.7471 3.47991 14.7103 3.0594 14.4282 2.82273ZM13.7617 4.82273C13.4797 4.58607 13.0592 4.62286 12.8225 4.90491C12.5858 5.18695 12.6226 5.60746 12.9047 5.84413C13.1867 6.08079 13.6072 6.04401 13.8439 5.76196C14.0806 5.47991 14.0438 5.0594 13.7617 4.82273Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4763 9.45045C15.8883 11.0385 13.3135 11.0385 11.7255 9.45045C11.5716 9.29658 11.4327 9.13343 11.3086 8.96282C12.8987 10.1191 15.1376 9.98009 16.5718 8.54592C18.006 7.11175 18.1449 4.87284 16.9887 3.28271C17.1593 3.40677 17.3225 3.54574 17.4763 3.69962C19.0644 5.28767 19.0644 7.8624 17.4763 9.45045Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9612"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryTm);
export default __webpack_public_path__ + "static/media/Country=TM.df9b0714c03c22eb9d5e1f327e4a6aaf.svg";
export { ForwardRef as ReactComponent };